/* eslint-disable import/prefer-default-export */
import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';

const CORRELATION_COOKIE_NAME = 'tglr_correlation_id';
const CORRELATION_COOKIE_TTL = 30 * 60 * 1000; // Cookie expiration time  (30 min) in ms

const getDomain = () => {
  const { hostname } = window.location;
  const parts = hostname.split('.');

  return parts.length > 2 ? parts.slice(-2).join('.') : hostname;
};

/**
 * Create a Cohesion CorrelationID and set it in a Cookie. This also refreshes the cookie's expiry.
 */
export const getCorrelationID = () => {
  const paramId = uuidv4();

  const expires = new Date(Date.now() + CORRELATION_COOKIE_TTL);
  new Cookies().set(CORRELATION_COOKIE_NAME, paramId, { expires, domain: `.${getDomain()}`, path: '/' });

  return paramId;
};
